import React, { useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { AddUser, UpdateUser } from "../../api/apirequest"; // Assuming you have an UpdateUser API function

function UserForm({ setNewpo, editRow, nav,fetchData }) {
  const [formData, setFormData] = useState({
    username: editRow?.Username || "",
    email: editRow?.Email || "",
    fullName: editRow?.FullName || "",
    phoneNumber: editRow?.PhoneNumber || "",
    role: editRow?.Role || "",
    passwordHash: editRow?.PasswordHash || "", // Assuming you have access to this field
  });
  const [loading, setLoading] = useState(false); // State to track loading/submission status
  const [error, setError] = useState(null);

  const roles = [
    { value: "admin", label: "Admin" },
    { value: "driver", label: "Driver" },
    { value: "mechanic", label: "Mechanic" },
    { value: "assist", label: "Assist" },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    if (name === "fullName") {
      const suggestedUsername = value.toLowerCase().replace(/\s+/g, "");
      setFormData((prevData) => ({ ...prevData, username: suggestedUsername }));
    }
  };

  const handleRoleChange = (selectedOption) => {
    setFormData((prevData) => ({ ...prevData, role: selectedOption.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true when form is being submitted
    setError("");

    try {
      let result;
      if (editRow) {
        // Update existing user
        const updateData = {
          ...formData,
          userId: editRow.UserID,
          IsActive: 1,
        };
        if (formData.password) {
          // Only update password if a new one was provided
          updateData.passwordHash = formData.password;
        }
        result = await UpdateUser(updateData);
      } else {
        // Add new user
        result = await AddUser({
          ...formData,
          isActive: 1,
          passwordHash:
            formData.password ||
            Math.floor(1000 + Math.random() * 9000).toString(),
        });
      }

      if (result && result.success) {
        toast.success(
          result.message ||
            (editRow
              ? "User updated successfully!"
              : "User created successfully!")
        );
        setNewpo(); // Close the form or reset the state
      } else {
        toast.error(
          result.message ||
            (editRow ? "Failed to update user." : "Failed to create user.")
        );
      }
    } catch (error) {
      console.error(error);
      toast.error("There was an error processing your request.");
    } finally {
      fetchData()
      setLoading(false); 
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>{editRow ? "Edit User" : "Add User"}</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.row}>
          <label style={styles.label}>
            Full Name:
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </label>
          <label style={styles.label}>
            Username:
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </label>
        </div>
        <div style={styles.row}>
          <label style={styles.label}>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </label>
          <label style={styles.label}>
            Phone Number:
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </label>
        </div>
        {nav && (
          <div style={styles.row}>
            <label style={styles.label}>
              Password:
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                style={styles.input}
                required={!editRow} // Only required if adding a new user
              />
            </label>
          </div>
        )}
        <div style={styles.row}>
          <label style={styles.label}>
            Role:
            <Select
              options={roles}
              value={roles.find((role) => role.value === formData.role)}
              onChange={handleRoleChange}
              styles={customSelectStyles}
              required
            />
          </label>
        </div>
        <button
          disabled={loading} // Disable the button when loading is true
          type="submit"
          style={{
            ...styles.button,
            backgroundColor: loading ? "grey" : "#007BFF",
          }}
        >
          {loading ? "Submitting..." : editRow ? "Update User" : "Add User"}
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    margin: "20px auto",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontFamily: "Arial, sans-serif",
    maxWidth: "800px",
    width: "90%", // Responsive width
  },
  header: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "24px", // Responsive font size
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  row: {
    display: "flex",
    flexDirection: "column", // Stack rows vertically on small screens
    marginBottom: "15px",
    gap: "15px", // Add gap between inputs
  },
  label: {
    flex: "1",
    fontSize: "14px",
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "8px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    marginTop: "5px",
    width: "100%", // Full width on small screens
  },
  button: {
    padding: "10px 15px",
    fontSize: "16px",
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    width: "100%", // Full width on small screens
  },
};

// Media queries for responsiveness
const customSelectStyles = {
  control: (base) => ({
    ...base,
    borderRadius: "4px",
    borderColor: "#ccc",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#888",
    },
    width: "100%", // Full width on small screens
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#007BFF" : "#fff",
    color: state.isSelected ? "#fff" : "#333",
    "&:hover": {
      backgroundColor: "#f1f1f1",
    },
  }),
};

export default UserForm;